<template>
<section id="forgot">
    <NavbarDefault selection route="/" />
    <el-progress :stroke-width="2" :color="getPrimaryColorHex.four" :show-text="false" :percentage="40" />
    <div class="container pt-5 success">
        <div class="row d-flex justify-content-center">
            <div class="col-10 box-message box-signup mb-4 mt-3">
                <ExclamationIcon size="18" class="mx-2" color="#E19700" />
                <p class="c-ndarkfour medium">
                    <span class="bold">Verifique sua caixa de entrada ou pasta de spam, para consultar seu código de validação.</span><br>
                    Para nossos e-mails retornarem para sua caixa de entrada, selecione o e-mail e clique em "não é spam”.
                </p>
            </div>
            <div class="col-4 mb-5 mt-4">
                <h2 :class="`text-center mb-4 c-${getPrimaryColor}four`">Valide seu e-mail</h2>
                <p class="text-center mb-0">
                    Digite o código que enviamos para seu e-mail:
                </p>
                <div class="d-flex justify-content-center mt-3 mb-5">
                    <span class="email-box">
                        <p class="bold">
                            {{ $store.state.user.infos.email }}
                        </p>
                    </span>
                </div>
                <div class="d-flex mb-3">
                    <el-input ref="first" @keydown.native="focusNextInput('first', 1, $event)" class="code-input" :class="`${getPrimaryColor} ${code.first.length == 1 ? 'is-success' : ''}`" v-model="code.first"/>
                    <el-input ref="second" @keydown.native="focusNextInput('second', 2, $event)" class="code-input" :class="`${getPrimaryColor} ${code.second.length == 1 ? 'is-success' : ''}`" v-model="code.second"/>
                    <el-input ref="third" @keydown.native="focusNextInput('third', 3, $event)" class="code-input" :class="`${getPrimaryColor} ${code.third.length == 1 ? 'is-success' : ''}`" v-model="code.third"/>
                    <el-input ref="fourth" @keydown.native="focusNextInput('fourth', 4, $event)" class="code-input" :class="`${getPrimaryColor} ${code.fourth.length == 1 ? 'is-success' : ''}`" v-model="code.fourth"/>
                    <el-input ref="fifth" @keydown.native="focusNextInput('fifth', 5, $event)" class="code-input" :class="`${getPrimaryColor} ${code.fifth.length == 1 ? 'is-success' : ''}`" v-model="code.fifth"/>
                </div>
                <div class="spacer"></div>
                <Button :disabled="!validateCodeInputs" size="large" @click="sendEmailCode" :color="getPrimaryColor">
                    Continuar
                </Button>
                <div class="mt-3 mb-5 text-center">
                    <span class="c-darkfour fs-14">Enviar o </span>
                    <router-link :class="getPrimaryColor" to="" @click.native="reSendEmailCodeToVerify">código novamente</router-link>
                </div>
            </div>
        </div>
    </div>
    <Footer />
</section>
</template>

<script>
import emailCodeVerify from '@/api/emailCodeVerify'
import reSendEmailCode from '@/api/reSendEmailCode'
import ExclamationIcon from '@/components/icons/Exclamation'
import Footer from '@/components/navigation/footer/Footer'
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import Cookies from 'js-cookie'
import getPartner from '@/utils/getPartner'

export default {
    components: {
        NavbarDefault,
        Footer,
        ExclamationIcon
    },
    data() {
        return {
            code: {
                first: '',
                second: '',
                third: '',
                fourth: '',
                fifth: '',
            },
            teste: '',
        }
    },
    computed: {
        validateCodeInputs() {
            return Object.values(this.code).every(input => input.length)
        }
    },
    watch: {
        'code.first': function(value) {
            if (value.length > 1) this.pasteCodeManually('first')
        },
        'code.second': function(value) {
            if (value.length > 1) this.pasteCodeManually('second')
        },
        'code.third': function(value) {
            if (value.length > 1) this.pasteCodeManually('third')
        },
        'code.fourth': function(value) {
            if (value.length > 1) this.pasteCodeManually('fourth')
        },
        'code.fifth': function(value) {
            if (value.length > 1) this.pasteCodeManually('fifth')
        }
    },
    methods: {
        pasteCodeManually(inputName) {
            const fullText = this.code[inputName]
            const inputEnum = ['first', 'second', 'third', 'fourth', 'fifth']
            const startIndex = inputEnum.indexOf(inputName)
            for (let index = startIndex; index < (fullText.length + startIndex); index++) {
                this.code[inputEnum[index]] = fullText.charAt(index - startIndex)
            }
            const focusInput = (fullText.length + startIndex) < 5 ? fullText.length + startIndex : 4
            this.$refs[inputEnum[focusInput]].focus()
        },
        focusNextInput(inputName, inputOrder, key) {
            //console.log(inputName, inputOrder, key)
            //if (key.code == 'KeyV' && key.ctrlKey && this.code[inputName].length) {
                // const fullText = this.code[inputName]
                // this.code.first = fullText[0]
                // this.code.second = fullText[1]
                // this.code.third = fullText[2]
                // this.code.fourth = fullText[3]
                // this.code.fifth = fullText[4]
                //this.pasteCodeManually(inputName)
            //} else 
            //if (['0','1','2','3','4','5','6','7','8','9','Backspace', 'Control', 'v'].includes(key.key)) {
            if (inputOrder == 5 && this.code[inputName].length) {
                this.$refs[inputName].clear()
            } else {
                this.code[inputName] = this.code[inputName][0] || ''
                const inputEnum = ['first', 'second', 'third', 'fourth', 'fifth']
                if (key.code != 'Backspace' && key.key != 'Control' && inputOrder < 5 && this.code[inputName].length) {
                    this.$refs[inputEnum[inputOrder]].focus()
                } else if (key.code == 'Backspace' && inputOrder > 1 && !this.code[inputName].length) {
                    this.$refs[inputEnum[inputOrder - 2]].focus()
                }
            }
            //} else {
                //this.$refs[inputName].clear()
            //}
        },
        async sendEmailCode() {
            const result = await emailCodeVerify({ verificationCode: `${this.code.first}${this.code.second}${this.code.third}${this.code.fourth}${this.code.fifth}`, partner: this.getWhiteLabel })
            if (result.ok) {
                    Cookies.set('token', result.payload.token, {
                    expires: 1,
                    domain: process.env.VUE_APP_ROOT_DOMAIN
                })
                this.$store.commit('user/setInfoSignUp', result.payload.token)
                 this.$store.commit('user/setVerificationCode', `${this.code.first}${this.code.second}${this.code.third}${this.code.fourth}${this.code.fifth}`)
                this.$router.push(`/signup/password`)
            } else {
                this.$notify({
                    title: `Código de confirmação inválido`,
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        async reSendEmailCodeToVerify() {
            const partner = await getPartner(this.getWhiteLabel)
            const result = await reSendEmailCode(partner)
            if (result.ok) {
                this.$notify({
                    title: `Código de verificação enviado com sucesso!`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.width-880{
    max-width:880px;
}
.spacer {
    height: 34px;
}
.email-box {
    background: #F7FAFD;
    border-radius: 6px;
    padding: 12px;
}
.input-code {
    text-align: center;
    &:after {
        content: "";
        position: absolute;
        width: 2px;
        height: 42px;
        background: #3D5DFC;
        border-radius: 2px;
        left: 5px;
    }
}
.fs-14 {
    font-size: 14px;
}
</style>
